// Paleta e opções base partilhadas pelos gráficos do Dashboard.
// Chart.js 2.x — não é preciso registar nada (ver ActivityPerformance).

export const STATUS_COLORS = {
  'In Progress': '#1565c0',
  'Planned':     '#8fa3bc',
  'Overdue':     '#c62828',
  'Closed':      '#2e7d32',
}

export const VENDOR_COLORS = {
  Nokia:    '#5f4bb6',
  Huawei:   '#e65100',
  Ericsson: '#1565c0',
}

// Go / No-Go (Item 22): verde = aprovado para rollout, âmbar = não.
export const ROLLOUT_COLORS = {
  'Go':    '#2e7d32',
  'No-Go': '#ed6c02',
}

export const SIDE_COLORS = ['#5f4bb6', '#e65100', '#00897b']
export const CAT_COLOR   = '#1565c0'
export const TYPE_COLOR  = '#00897b'
export const OWNER_COLOR = '#ad1457'

// Opções comuns — sem animação pesada, tooltips consistentes (Chart.js 2.x).
// O padding extra deixa espaço para os rótulos de valor desenhados pelos plugins.
export const baseBarOptions = (horizontal = false) => ({
  maintainAspectRatio: false,
  legend: { display: false },
  layout: { padding: horizontal ? { right: 34 } : { top: 20 } },
  scales: {
    xAxes: [{ gridLines: { display: horizontal, color: '#eef1f6' }, ticks: { beginAtZero: true, precision: 0, fontColor: '#4a5568' } }],
    yAxes: [{ gridLines: { display: !horizontal, color: '#eef1f6' }, ticks: { beginAtZero: true, precision: 0, fontColor: '#4a5568' } }],
  },
})

export const stackedBarOptions = {
  maintainAspectRatio: false,
  legend: { position: 'bottom', labels: { boxWidth: 12, fontColor: '#4a5568', padding: 12 } },
  layout: { padding: { top: 20 } },
  scales: {
    xAxes: [{ stacked: true, gridLines: { display: false }, ticks: { fontColor: '#4a5568' } }],
    yAxes: [{ stacked: true, gridLines: { color: '#eef1f6' }, ticks: { beginAtZero: true, precision: 0, fontColor: '#4a5568' } }],
  },
}

export const doughnutOptions = {
  maintainAspectRatio: false,
  cutoutPercentage: 62,
  legend: { position: 'right', labels: { boxWidth: 12, fontColor: '#4a5568', padding: 10 } },
}
